// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components';
import { baseDark } from 'crehana-ui/styles/colors';
import Media from 'Shared/ui/Media';
import { MainSectionBackgroundProps } from './types';

const Overlay = styled.div`
  background: radial-gradient(
    119.86% 119.86% at 50% -19.86%,
    rgba(15, 17, 36, 0) 23.77%,
    ${baseDark} 100%
  );
`;

const Background: React.FC<MainSectionBackgroundProps> = ({
  backgroundImage,
}) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full z-5">
      <Media from="sm" defaultMatches={false}>
        <picture className="block absolute inset-0 overflow-hidden bg-base-dark">
          <source
            media="(max-width: 768px)"
            srcSet={backgroundImage.webp}
            type="image/webp"
          />
          <img
            src={backgroundImage.jpg}
            alt="cover"
            className="h-full w-full object-cover"
          />
        </picture>
      </Media>
      <Overlay className="absolute w-full h-full top-0 left-0 hidden sm:block lg:hidden" />
    </div>
  );
};

export default Background;
